module.exports = __webpack_public_path__ + "static/media/obligaciones.588907fb.png";